import { defineComponent as _defineComponent } from 'vue'
import {watch} from 'vue'
type Emits = {
    (e: 'closeToast'):void
}
type Props ={
    message?: string
    time?: number
    showToast?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'toast',
  props: {
    message: null,
    time: null,
    showToast: { type: Boolean }
  },
  emits: ["closeToast"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'closeToast'):void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    message?: string
    time?: number
    showToast?: boolean
}






watch(()=>props.showToast, ()=>{
    if(props.showToast){
        setTimeout(()=>{
            emit('closeToast')
        },props.time)
    }
})


const __returned__ = { emit, props, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})